module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07453_banner_800x600.8ed2b8c1.png";